import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
} from "@mui/material";

const ViewUpdateDetails = ({ oldValue, newValue }) => {
  const parseValues = (valueStr) => {
    if (!valueStr) return {};
    const lines = valueStr.split(/\r?\n/);
    const result = {};
    lines.forEach((line) => {
      if (line.trim()) {
        const parts = line.split(" : ");
        if (parts.length >= 2) {
          const field = parts[0].trim();
          const value = parts.slice(1).join(" : ").trim().replace(/;$/, "");
          result[field] = value;
        }
      }
    });
    return result;
  };

  const oldMap = parseValues(oldValue);
  const newMap = parseValues(newValue);

  const allFields = Array.from(new Set([...Object.keys(oldMap), ...Object.keys(newMap)]));

  return (
    <Box sx={{ p: 2 }}>
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              <TableCell>
                <strong>Field Name</strong>
              </TableCell>
              <TableCell>
                <strong>Old Value</strong>
              </TableCell>
              <TableCell>
                <strong>New Value</strong>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allFields.length > 0 ? (
              allFields.map((field) => (
                <TableRow key={field}>
                  <TableCell>{field}</TableCell>
                  <TableCell sx={{ color: "error.main" }}>{oldMap[field] || "-"}</TableCell>
                  <TableCell sx={{ color: "success.main" }}>{newMap[field] || "-"}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={3} align="center">
                  No details available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ViewUpdateDetails;
